import React from "react";
import publicConfig from "../common/public-config";
import { composeDataMethods } from "@lululemon/mwa-utils";
import { SessionProvider } from "@lululemon/auth-sdk";
const withSessionProvider = Component => {
  const WithSessionProvider = props => {
    var _publicConfig$okta;
    return /*#__PURE__*/React.createElement(SessionProvider, {
      oktaConfig: (publicConfig === null || publicConfig === void 0 ? void 0 : (_publicConfig$okta = publicConfig.okta) === null || _publicConfig$okta === void 0 ? void 0 : _publicConfig$okta.config) || (publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.okta) || {},
      shapeConfig: (publicConfig === null || publicConfig === void 0 ? void 0 : publicConfig.shape) || {}
    }, /*#__PURE__*/React.createElement(Component, props));
  };
  return composeDataMethods(Component, {})(WithSessionProvider);
};
export default withSessionProvider;